import React from 'react';

function toSafeHtml(text = '') {
  const escaped = text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

  return escaped
    .replace(/&lt;(\/?(?:strong|em|u|code))&gt;/g, '<$1>')
    .replace(/&lt;br\s*\/?&gt;/g, '<br/>');
}

export default function FormattedText({ as: Tag = 'span', className, text }) {
  return <Tag className={className} dangerouslySetInnerHTML={{ __html: toSafeHtml(text || '') }} />;
}
